export default __webpack_public_path__ + "static/media/manor2.391a6406.svg";